{
  "chargeTableConfig": {
    "columns": [
      {
        "fieldName": "name",
        "displayName": "Name",
        "dataType": "CLICKABLE",
        "styleConfig": {
          "type": "hyper-link"
        },
        "thStyleConfig": {
          "width": "350px"
        }
      },
      {
        "fieldName": "code",
        "displayName": "Charge Code",
        "dataType": "STRING",
        "styleConfig": {
          "type": "badge"
        }
      },
      {
        "fieldName": "description",
        "displayName": "Description",
        "dataType": "STRING"
      },
      {
        "fieldName": "hsnOrSacCode",
        "displayName": "HSN/SAC Code",
        "dataType": "STRING"
      },
      {
        "fieldName": "active",
        "displayName": "Status",
        "dataType": "BOOLEAN",
        "valueMap": {
          "true": "Active",
          "false": "Inactive"
        },
        "styleConfig": {
          "type": "status"
        }
      },
      {
        "fieldName": "storageCharge",
        "displayName": "Storage Charge",
        "dataType": "STRING",
        "valueMap": {
          "true": "Yes",
          "false": "No"
        },
        "styleConfig": {
          "type": "badge"
        }
      },
      {
        "fieldName": "printName",
        "displayName": "Print Name",
        "dataType": "STRING"
      },
      {
        "fieldName": "createdDate",
        "displayName": "Created Date",
        "dataType": "DATETIME"
      },
      {
        "fieldName": "createdBy",
        "displayName": "Created By",
        "dataType": "STRING",
        "hasLookup": true,
        "styleConfig": {
          "type": "user-avatar"
        }
      },
      {
        "fieldName": "modifiedDate",
        "displayName": "Modified Date",
        "dataType": "DATETIME",
        "sortable": true
      },
      {
        "fieldName": "modifiedBy",
        "displayName": "Modified By",
        "dataType": "STRING",
        "hasLookup": true,
        "styleConfig": {
          "type": "user-avatar"
        }
      }
    ]
  },
  "searchBarConfig": {
    "placeHolder": "Search charge by name or code",
    "filters": [
      {
        "name": "NAME_CONTAINS",
        "alias": "Name"
      },
      {
        "name": "CODE_CONTAINS",
        "alias": "Code"
      }
    ]
  },
  "filterConfig": {
    "filterFields": [
      {
        "name": "hsnSacCode",
        "displayLabel": "HSN/SAC Code",
        "dataType": "STRING",
        "operatorToFilterMap": {
          "EQ": "HSN_OR_SAC_CODE_EQUALS"
        }
      },
      {
        "name": "name",
        "displayLabel": "Name",
        "dataType": "STRING",
        "operatorToFilterMap": {
          "EQ": "NAME_EQUALS",
          "CONTAINS": "NAME_CONTAINS"
        }
      },
      {
        "name": "code",
        "displayLabel": "Code",
        "dataType": "STRING",
        "operatorToFilterMap": {
          "EQ": "CODE_EQUALS",
          "CONTAINS": "CODE_CONTAINS"
        }
      },
      {
        "name": "isActive",
        "displayLabel": "Active",
        "dataType": "BOOLEAN",
        "operatorToFilterMap": {
          "EQ": "ACTIVE_EQUALS"
        }
      },
      {
        "name": "service_id",
        "displayLabel": "Service",
        "dataType": "STRING",
        "hasLookup": true,
        "searchConfig": {
          "apiUrl": "v1/services/list",
          "filterByKeys": ["NAME_CONTAINS", "CODE_CONTAINS"],
          "limit": 10,
          "multiSelect": true,
          "orderBy": { "name": "asc" },
          "bindLabel": "name",
          "returnRawValue": false,
          "bindValue": "id",
          "displayColumns": [{ "key": "name", "header": "Name" }],
          "additionalFilters":{
            "name": "IS_ACTIVE",
            "alias": "active",
            "operator": "EQ",
            "value": ["true"]
          }
        },
        "operatorToFilterMap": {
          "IN": "SERVICE_CONTAINS"
        }
      }
    ],
    "useNewContract": true
  }
}
